import { useState, useEffect } from 'react';

export function useDate({ updateWhen = "date_change" }) {
  function createDate() {
    return new Date();
  }

  const [date, setDate] = useState(createDate());

  useEffect(() => {
    const interval = setInterval(() => {
      const newDate = createDate();

      if (updateWhen === "minute_change") {
        if (newDate.getMinutes() !== date.getMinutes()) {
          setDate(newDate);
        }
      } else if (updateWhen === "date_change") {
        if (
          newDate.getDate() !== date.getDate() ||
          newDate.getMonth() !== date.getMonth() ||
          newDate.getFullYear() !== date.getFullYear()
        ) {
          setDate(newDate);
        }
      }

    }, 3000);
    return () => clearInterval(interval);
  }, [date, updateWhen]);

  return createDate();
}